import { render, staticRenderFns } from "./v-partner.vue?vue&type=template&id=858b20e6&"
import script from "./v-partner.vue?vue&type=script&lang=js&"
export * from "./v-partner.vue?vue&type=script&lang=js&"
import style0 from "./v-partner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports